export default __webpack_public_path__ + "static/media/Pst Gbolahan Fowowe.f6ddfa85.jfif";